import React, { useMemo } from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import SummaryStats from './BarCharts/SummaryStats';
import BarChartTooltip from './BarCharts/BarChartTooltip';

function PriorityGraphUserNeeds({processedData}) {

   const chartData = useMemo(() => {
    return processedData?.chart_data || [];
  }, [processedData?.chart_data]);

 const categoryColors = {
    "Infrastructure" : '#F59E0B',
    "Housing" : '#EF4444',
    "Transportation" : '#10B981',
    "Safety" : '#8B5CF6',
    "Education": '#3B82F6',
    'Health': '#6B7280',
    "Economy" : '#C40C0C',
    "Environment": '#FF6500',
    "Community" : '#10439F',
    "Services": '#E8751A'

  };

 const getBarColor = (item) => {
    return categoryColors[item.name] || categoryColors['Uncategorized'];
  };


   return (<div className="w-full bg-white rounded-lg shadow-lg p-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
        <div className="flex items-center mb-4 md:mb-0">
          <div>
            <h2 className="text-2xl font-bold text-gray-800">User Needs Priority Analysis</h2>
            <p className="text-sm text-gray-600">Live data from survey processing pipeline</p>
          </div>
        </div>
        
      </div>


      {processedData && <SummaryStats data={processedData} />} 
      
      <div className="bg-gray-50 text-black rounded-lg p-4">
        <h3 className="text-lg font-medium text-gray-800 mb-4 flex items-center">
          Priority Ranking
        </h3>
        <ResponsiveContainer width="85%" height={500}>
          <BarChart
            data={chartData}
            margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis 
              dataKey="name"
              angle={-45}
              textAnchor="end"
              height={80}
              fontSize={12}
              interval={0}
              label={{ value: 'Categories', position: "insideBottomRight", margin: {top: 30}}}
            />
            <YAxis 
              label={{ value: 'Importance Score (%)', angle: -90, position: 'insideLeft' }}
              tickFormatter={(value) => `${(value * 100).toFixed(0)}%`}
              domain={[0, 'dataMax']}
            />
            <Tooltip content={<BarChartTooltip />} />
            <Bar 
              dataKey="importance" 
              name="Importance Score"
              radius={[4, 4, 0, 0]}
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${entry.id}-${index}`} fill={getBarColor(entry)} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>



    </div>)
}

export default PriorityGraphUserNeeds
